import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import SMTeamLogo from '../SMTeamLogo';
import eventify from 'Eventify';
import DateFormatted from '../DateFormatted';
import RCore from 'RCore';
const i18Common = require('../../../../i18/i18.Common');

const i18 = RCore.getTranslation.bind({ dict: i18Common });
const scoreWidth = 100;

const Wrapper = styled.div`
    margin: 4px 0;
`;

const MatchCellHeader = styled.div`
    color: ${props => props.theme.primaryTextColor};
    padding: 10px 10px;
    text-align: center;
`;

const Cell = styled.div`
    position: relative;
    margin: 0;
    white-space: nowrap;
    text-align: center;
    display: flex;
    align-items: center;
    .team-home {
        text-align: right;
    }
    .team-away {
        text-align: left;
    }
`;

const Team = styled.div`
    width: calc(50% - 60px);
    white-space: nowrap;
    text-align: center;
    font-size: 24px;
    font-weight: normal;
    line-height: 60px;
    background-color: ${props => props.theme.content.backgroundColor};
    color: ${props => props.theme.color};
    & > * {
        vertical-align: middle;
        display: inline-block;
    }
`;

const Score = styled.div`
    position: relative;
    width: 120px;
    height: 60px;
    position: relative;
    color: ${props => (props.isLive ? props.theme.primaryTextColor : props.theme.content.accentTextColor)};
    display: flex;
    font-size: 14px;
    line-height: 1.1;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .top-sub-small {
        font-size: 16px;
        line-height: 22px;
        text-transform: uppercase;
    }
    .top-sub {
        font-size: 16px;
        line-height: 16px;
        font-weight: 700;
        text-transform: uppercase;
    }
    .top-sub-score {
        font-size: 32px;
        font-weight: 700;
    }
    .score {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 32px;
        line-height: 34px;
        font-weight: 700;
        flex-grow: 1.2;
    }

    .tv-info {
        width: 100%;
        flex-grow: 1;
        display: flex;
        text-transform: uppercase;
        font-weight: 700;
        align-items: center;
        justify-content: center;
        font-size: 14px;
    }

    &.__c__b2_style1 {
        & * {
            background-color: transparent !important;
        }
    }

    .__c__c4_style1 {
        &,
        & * {
            background-color: transparent !important;
        }
    }

    * {
        z-index: 2;
    }
`;

const ScoreBg = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    background-color: ${props => (props.isLive ? props.theme.primaryColor : props.theme.content.accentColor)};
`;

const IsLiveLabel = styled.div`
    background: ${props => props.theme.primaryColor};
    color: ${props => props.theme.primaryTextColor};
    text-transform: uppercase;
    font-size: 18px;
    font-weight: 700;
    transform: translate(0, -50%) rotate(-90deg);
    position: absolute;
    width: 60px;
    height: 30px;
    line-height: 22px;
    box-sizing: border-box;
    padding: 3px 0 5px;
    left: -15px;
    top: 50%;
    transform-origin: center;
`;

const TeamNameHome = styled.div`
    display: inline-block;
    width: calc(100% - 70px);
    vertical-align: middle;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    text-align: right;
    padding-right: 15px;
    box-sizing: border-box;
`;

const TeamNameAway = TeamNameHome.extend`
    text-align: left;
    padding-left: 15px;
`;

const OddsBar = styled.div`
    color: ${props => props.theme.primaryColor};
    padding-bottom: 3px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    i {
        color: ${props => props.theme.content.accent2TextColor};
        font-style: normal;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translate(8px, -50%);
        font-weight: normal;
        font-size: 1rem;
    }

    > * {
        padding: 6px 0;
        color: ${props => props.theme.color};
        background-color: ${({ theme }) => theme.content.accent2Color};
        width: 120px;
        position: relative;
        font-weight: ${({ theme }) => theme.fonts.main.bold || 'bold'};
        font-size: 20px;
        line-height: 1em;
    }
    .odd-type-1 {
        padding-left: 15px;
        padding-right: 15px;
    }

    .odd-type-X {
    }

    .odd-type-2 {
        padding-left: 15px;
        padding-right: 15px;
    }
`;

class MatchCell extends React.Component {
    constructor(props) {
        super(props);
    }

    static contextTypes = {
        info: PropTypes.object,
        screenSizeObserver: PropTypes.object,
        moment: PropTypes.func,
    };

    render() {
        let { event, lang, betOffer } = this.props;
        event = eventify(event);

        const tvInfo = event.channel && event.channel.name && <div className="tv-info">{event.channel.name}</div>;
        const isToday = this.context.moment(event.startDate).isSame(new Date(), 'day');
        const isFinished = event.isFinished();
        const isComing = event.isComing();
        const isLive = event.isLive();

        // console.log('--->', 'betOffer', ['1','x','2'].map(o => {
        //     const odd = betOffer.outcomes.find(t => t.type === o).odds.toFixed(2);
        //
        //     return (
        //
        //     );
        // }));

        return (
            <Wrapper>
                <Cell>
                    {isLive && <IsLiveLabel>Live</IsLiveLabel>}
                    <Team className="team-home">
                        <TeamNameHome>{event.homeName}</TeamNameHome>

                        <SMTeamLogo
                            tournamentId={event.tournamentTemplateId}
                            teamId={event.homeId}
                            height={40}
                            style={{
                                marginRight: 15,
                                minWidth: 40,
                            }}
                        />
                    </Team>
                    <Score isLive={isLive}>
                        <ScoreBg className="__c__b2_style1" />
                        {isFinished && (
                            <div>
                                {this.props.showDate && (
                                    <div className="top-sub-small __c__c4_style1">
                                        <DateFormatted
                                            className="time"
                                            el="div"
                                            date={event.startDate}
                                            type="DATE_SHORT"
                                        />
                                    </div>
                                )}
                                <div className="top-sub-score __c__c4_style1">
                                    {event.score.home + ' - ' + event.score.away}
                                </div>
                            </div>
                        )}

                        {event.isCancelled() && (
                            <div className="__c__c4_style1">{i18('status.short.cancelled', lang)}</div>
                        )}
                        {event.isPostponed() && (
                            <div className="__c__c4_style1">{i18('status.short.postponed', lang)}</div>
                        )}
                        {isLive && (
                            <div>
                                <div className="top-sub-score __c__c4_style1">
                                    {event.score.home + ' - ' + event.score.away}
                                </div>
                                {tvInfo}
                            </div>
                        )}
                        {isComing &&
                            !event.isCancelled() &&
                            !event.isPostponed() &&
                            (isToday || this.props.timeOnly) && (
                                <div>
                                    <div className="top-sub __c__c4_style1">
                                        <DateFormatted className="time" el="div" date={event.startDate} type="TIME" />
                                    </div>
                                    {tvInfo}
                                </div>
                            )}
                        {isComing &&
                            !event.isCancelled() &&
                            !event.isPostponed() &&
                            !(isToday || this.props.timeOnly) && (
                                <div>
                                    <div className="top-sub __c__c4_style1">
                                        <DateFormatted
                                            className="time"
                                            el="div"
                                            date={event.startDate}
                                            type="DATE_SHORT"
                                        />
                                    </div>
                                    <div className="__c__c5_style1">
                                        <DateFormatted className="time" el="div" date={event.startDate} type="TIME" />
                                    </div>
                                </div>
                            )}
                    </Score>
                    <Team className="team-away">
                        <SMTeamLogo
                            tournamentId={event.tournamentTemplateId}
                            teamId={event.awayId}
                            height={40}
                            style={{ marginLeft: 15, minWidth: 40 }}
                        />

                        <TeamNameAway>{event.awayName}</TeamNameAway>
                    </Team>
                </Cell>
                {betOffer && (
                    <OddsBar>
                        {['1', 'x', '2'].map(o => {
                            const odd = betOffer.outcomes
                                .find(t => t.type.toLowerCase() === o.toLowerCase())
                                .odds.toFixed(2);

                            return (
                                <div key={o} className={`odd-type-${o}`}>
                                    <i>{o}</i> {odd}
                                </div>
                            );
                        })}
                    </OddsBar>
                )}
            </Wrapper>
        );
    }
}

MatchCell.propTypes = {
    event: PropTypes.object.isRequired,
};

const Container = ({ children }) => <div>{children}</div>;

export default { MatchCellHeader, MatchCell, Container };



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/views/matchCell/MainMatchCell.js
 **/